import { render, staticRenderFns } from "./OnDemandTask.vue?vue&type=template&id=d4066404&scoped=true&"
import script from "./OnDemandTask.vue?vue&type=script&lang=js&"
export * from "./OnDemandTask.vue?vue&type=script&lang=js&"
import style0 from "./OnDemandTask.vue?vue&type=style&index=0&id=d4066404&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4066404",
  null
  
)

export default component.exports